import { z } from 'zod';

export const ASSOCIATED_TYPES = [
  'AUTHORITY',
  'SCHEME',
  'SERVICE_USER',
] as const;

export const AssociatedTypeSchema = z.enum(ASSOCIATED_TYPES);
export type AssociatedType = z.infer<typeof AssociatedTypeSchema>;
